// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"cce7bb29","977":"01172a94"}[chunkId] + ".chunk.js";
};